import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: `20px 20px 0px`,
  },
  centerAlign: {
    alignItems: 'center',
  },
  iconButtonColor: {
    marginLeft: 30,
    color: theme.palette.neutralDark,
  },
  pivotDisplayWrapper: {
    padding: `10px 25px 10px 10px`,
    cursor: 'pointer',
  },
  width5: {
    width: 5,
  },
  width10: {
    width: 10,
  },

  countColor: {
    color: 'white',
  },
}));
